/* KAPIBARAN V4. Manual hero switching only; safe on theme editor re-render. */
(() => {
  if (window.__kb4HeroInstalled) return;
  window.__kb4HeroInstalled = true;
  const show = (root, id) => {
    if (!(root instanceof HTMLElement)) return;
    const slides = [...root.querySelectorAll('[data-kb4-slide]')];
    const selected = slides.find(slide => slide.dataset.kb4Block === id);
    if (!selected) return;
    slides.forEach(slide => { slide.hidden = slide !== selected; });
    root.querySelectorAll('[data-kb4-show]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.kb4Show === id));
    });
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-kb4-show]');
    if (!button) return;
    show(button.closest('[data-kb4-hero]'), button.dataset.kb4Show);
  });
  document.addEventListener('shopify:block:select', event => {
    if (!(event.target instanceof Element)) return;
    const slide = event.target.closest('[data-kb4-slide]');
    if (slide) show(slide.closest('[data-kb4-hero]'), slide.dataset.kb4Block);
  });
})();
